<template>
  <div class="main-nav-wrap">
    <div class="mobile-header">
      <img src="../assets/header_blank.jpg" class="bg" alt=""/>
      <router-link to="/grusswort">
        <img src="../assets/logo.png" class="logo" alt=""/>
      </router-link>
    </div>
    <router-link class="text-logo" to="/liederschatz-wozu">
      <span class="big">Geh aus, mein Herz</span>
      <br><span class="small">Evangelischer Liederschatz | 22+2 Lieder</span>
    </router-link>
    <div class="main-nav">
      <nav class="nav-list">
        <router-link class="link" to="/grusswort">Grußwort</router-link>
        <router-link class="link" to="/liederschatz-wozu">Liederschatz wozu?</router-link>
        <router-link class="link" to="/kontakt">Ansprechpartner</router-link>
        <router-link class="link" to="/arbeitshilfen">Arbeitshilfen</router-link>
        <social-links/>
      </nav>
    </div>
  </div>

</template>

<script>

import SocialLinks from "./SocialLinks";

export default {
  components: {
    SocialLinks
  }
}
</script>